import DialogForm from '@/agilis/components/DialogForm/DialogForm.vue'

export default {
  name: 'dialogFormMixin',

  components: {
    DialogForm
  },

  data () {
    return {
      editingForm: null
    }
  },

  methods: {
    // /////////////////////////////////////////////////////////////////////////////////////////////////
    // Gestione Dialog con il form: questa funzione torna una promise con il risultato del submit del form
    // promise rejettata in caso di cancel del form
    // /////////////////////////////////////////////////////////////////////////////////////////////////
    openFormDialog (model, fields, formRows) {
      return new Promise((resolve, reject) => {
        this.editingForm = {
          model,
          fields,
          formRows,
          fnResolve: (...args) => {
            resolve(...args)
            this.editingForm = null
          },
          fnReject: (e) => {
            reject(e)
            this.editingForm = null
          }
        }
      })
    }
    // /////////////////////////////////////////////////////////////////////////////////////////////////
  }
}
